module.exports = __webpack_public_path__ + "static/2-fea1cd7828f546c61f52d46c66caed6d.jpeg";